import { render, staticRenderFns } from "./StoresDistributionCard.vue?vue&type=template&id=f9167f4e&scoped=true"
import script from "./StoresDistributionCard.vue?vue&type=script&lang=js"
export * from "./StoresDistributionCard.vue?vue&type=script&lang=js"
import style0 from "./StoresDistributionCard.vue?vue&type=style&index=0&id=f9167f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9167f4e",
  null
  
)

export default component.exports